import { useMutation } from '@apollo/client';
import { message } from 'antd';
import { PROCESS_TOY_SCHEDULE_ORDERS } from '../graphql/Mutations';

export const isOrderItemFailed = (item) => !!item?.error;

const getOrderErrorReason = (error) =>
  `${error}`?.match(/^[A-Z0-9_]+:\s*(.*)$/s)?.[1] || `${error}`;

const getFailureReasons = (failedItems = []) =>
  [
    ...new Set(
      failedItems?.map((item) => getOrderErrorReason(item?.error)?.trim()),
    ),
  ]
    ?.filter(Boolean)
    ?.join(' ');

const useToyScheduleOrders = ({ userNumber }) => {
  const [processOrders, { loading }] = useMutation(
    PROCESS_TOY_SCHEDULE_ORDERS,
    { onError() {} },
  );

  const placeWeekOrder = async (payload) => {
    const response = await processOrders({
      variables: { data: { userNumber, ...payload } },
    });
    if (!response?.data?.processToyScheduleOrders) return null;
    const items = response?.data?.processToyScheduleOrders?.data || [];

    const failedItems = items?.filter(isOrderItemFailed);
    const failedCount = failedItems?.length;
    if (failedCount) {
      const reasons = getFailureReasons(failedItems);
      message?.[failedCount === items?.length ? 'error' : 'warning'](
        failedCount === items?.length
          ? `Order not placed. ${reasons}`
          : `${failedCount} of ${items?.length} toy(s) could not be ordered. ${reasons}`,
      );
    } else {
      message?.success(
        response?.data?.processToyScheduleOrders?.message ||
          `${items?.length} toy(s) processed.`,
      );
    }
    return items;
  };

  return { loading, placeWeekOrder };
};

export default useToyScheduleOrders;
